import { Domaine } from './domaine.model';
import { Service } from './service.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class Abonnement {
    static readonly jsonMap = {
        id: { key: 'id', optional: true },
        idOrganisme: { key: 'idOrganisme', optional: true },
        service: { key: 'idService', converter: new (DataIdConverterFactory.build(Service, 'services'))(), optional: true },
        domaine: { key: 'idDomaine', converter: new (DataIdConverterFactory.build(Domaine, 'domaines'))(), optional: true }
    };

    public id: number;
    public idOrganisme: number;
    public service: Service;
    public domaine: Domaine;
}
